import React from "react";
import Router from "next/router";
import Countdown from './Countdown'
import CopyView from './CopyView'
import { DepositHeader } from '../index'
import Modal from "./Modal";
import SuccessPageCon from '$Deposits/Components/Components/SuccessPage'

class SuccessPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };

    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentDidMount() {

    }
    componentWillUnmount() {

    }


    render() {

        return (
            <>
                <SuccessPageCon
                    SuccessPage={(propCon) => {
                        const {
                            MethodsActive,
                            DepositPayments,
                            HistoryClick,
                            onChange,
                            backClick,
                            money,
                            LivechatClick,
                            times,
                            DepositBouns,
                            bonusName,
                            BackClick,
                            BackMyPromo
                        } = propCon
                        const { transactionId } = DepositPayments || {};
                        let { methods } = MethodsActive;
                        let flag1 = ['LB','QD','BQR'].some((item)=>item === methods);
                        let flag2 = ['CC'].some((item)=>item === methods);
                        let isGetBound = false
                        return (
                            <div className='sucessModal'>
                                <div className='sucessModalCenter'>
                                    <div className="viewArea">
                                        <div className="successIcon"><span></span></div>
                                        <p className="successTitle">Gửi Lệnh Thành Công</p>

                                        <div className="steps">
                                            <div className="stepsList">
                                                <span className="stepIcon" />
                                                <span className="stepA">Gửi Lệnh Thành Công</span>
                                            </div>
                                            <div className="stepsList">
                                                <span className="borders" />
                                                <span className="borderItem">Đang Xử lý</span>
                                            </div>
                                            <div className="stepsList">
                                                <span className="rounds" />
                                                <span className="roundsItem">Dự kiến trong <Countdown times={times} /> phút</span>
                                            </div>
                                        </div>

                                        {/* 金额 */}
                                        <div className='amount'>
                                            <span className='amountTitle'>Số Tiền Gửi (1=1,000)</span>
                                            <span className='amountValue'>{money} đ</span>
                                        </div>

                                        <CopyView
                                            copyTitle={'Mã Giao Dịch'}
                                            copyValue={transactionId}
                                            copyType={'transactionId'}
                                            redTip={false}
                                        />
                                    </div>
                                    {
                                        isGetBound &&
                                        <div className="offerDetails">
                                            <span className="offerTitle">{bonusName}</span>
                                            <div className="offerItem">
                                                <div>Số Tiền Gửi Yêu Cầu</div>
                                                <div>{money == "" ? "0" : money} đ</div>
                                            </div>
                                            <div className="offerItem">
                                                <div>Số Tiền Gửi Yêu Cầu</div>
                                                <div>{DepositBouns?.BonusAmount} đ</div>
                                            </div>
                                            <div className="offerItem">
                                                <div>Tổng Doanh Thu Cược</div>
                                                <div>{DepositBouns?.TurnoverAmount} đ</div>
                                            </div>
                                        </div>
                                    }

                                    <div onClick={LivechatClick} className="successTrips">
                                        Số tiền sẽ được cập nhật vào tài khoản của bạn trong vòng {flag1 ? '30' : (flag2 ? '15' : '10')} phút. Trong thời gian chờ bạn có thể quay lại trang chủ để tiếp tục cược. Nếu có thắc mắc gì có thể <span>Liên Hệ Live Chat</span> để được hỗ trợ.
                                    </div>
                                    {isGetBound || bonusName ?
                                        <>
                                            <div
                                                className={'submitBtnActive'}
                                                onClick={() => { BackMyPromo() }}
                                            >
                                                Xem Trạng Thái Khuyến Mãi
                                            </div>
                                            <div className={'submitBorderActive'}
                                                onClick={() => { Router.push("/"); }}>
                                                Trở Về Trang Chủ
                                            </div>
                                        </> 
                                            :
                                        <>
                                            <div
                                                className={'submitBtnActive'}
                                                onClick={() => { HistoryClick('Deposit') }}
                                            >
                                                Xem Lịch Sử Giao Dịch
                                            </div>
                                            <div
                                                className={'submitBorderActive'}
                                                onClick={onChange}
                                            >
                                                Trở Về Trang Gửi Tiền
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                        )
                    }}

                />

            </>
        );
    }
}

export default SuccessPage


